import { render, staticRenderFns } from "./FormFiles.vue?vue&type=template&id=174762d6&scoped=true&"
import script from "./FormFiles.vue?vue&type=script&lang=js&"
export * from "./FormFiles.vue?vue&type=script&lang=js&"
import style0 from "./FormFiles.vue?vue&type=style&index=0&id=174762d6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "174762d6",
  null
  
)

export default component.exports